import React from "react";
import { statusText, statusTone } from "../model/shipmentStatus";
import { formatPesos, MANAGEMENT_LABELS, universeClass, universeLabel } from "../model/towerFormat";
import { hasCoordinates } from "../model/towerShared";
import type { TowerShipment } from "../../../types/controlTower";

// Lista de envíos del detalle del chofer: cliente primero, tipo con su color,
// "Ver en mapa" y los de días anteriores marcados.
export default function DriverShipmentTable({
  shipments,
  operationalDateLabel,
  onShowOnMap,
}: {
  shipments: TowerShipment[];
  operationalDateLabel: string;
  onShowOnMap: (shipmentId: string) => void;
}) {
  return (
    <div className="tower-table-scroll">
      <table className="tower-table">
        <thead>
          <tr>
            <th>Cliente / tracking</th>
            <th>Destino</th>
            <th>Zona</th>
            <th>Tipo</th>
            <th>Estado actual</th>
            <th>{operationalDateLabel}</th>
          </tr>
        </thead>
        <tbody>
          {shipments.map((s) => (
            <tr key={s.id}>
              <td>
                <strong className="tower-client">{s.client}</strong>
                <small>{s.tracking}</small>
                {s.management && <span className="tower-state pending">{MANAGEMENT_LABELS[s.management]}</span>}
                {s.collection ? <small className="tower-collection">Cobra {formatPesos(s.collection)}</small> : null}
              </td>
              <td>
                {s.address || "Sin dirección"}
                <small>{s.locality || "Sin localidad"}</small>
                {hasCoordinates(s) ? (
                  <button type="button" className="tower-show-on-map" onClick={() => onShowOnMap(s.id)}>
                    Ver en mapa
                  </button>
                ) : (
                  <small className="tower-muted">Sin coordenadas</small>
                )}
              </td>
              <td>
                {s.zone === "Sin clasificar" ? "Por revisar" : s.zone}
                {s.zoneFromDriver && (
                  <small title="La localidad y el código postal no alcanzaban para ubicarlo: tomó la zona en la que reparte este chofer hoy.">
                    Según su chofer
                  </small>
                )}
              </td>
              <td>
                <span className={`tower-type ${universeClass(s.shippingUniverse)}`}>
                  {s.shippingMode === "FLEX_TURBO" ? "Flex Turbo" : universeLabel(s.shippingUniverse)}
                </span>
                <small>{s.origin}</small>
              </td>
              <td>
                <span className={`tower-state ${statusTone(s)}`}>{statusText(s)}</span>
                <small>{s.rawStatus}</small>
                <small>{s.stateDate || "Sin fecha de estado"}</small>
              </td>
              <td>
                {s.operationalDate || "Sin fecha"}
                {s.carryover && (
                  <span
                    className="tower-state previous"
                    title="Sigue con este chofer desde otro día, sin movimiento hoy."
                  >
                    De días anteriores
                  </span>
                )}
              </td>
            </tr>
          ))}
          {shipments.length === 0 && (
            <tr>
              <td colSpan={6} className="tower-empty">
                No hay envíos con estos filtros.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
